import React, {useEffect, useState} from 'react';



import {Box, Button, Form, FormField, Grid, Grommet, grommet, Heading, Text, TextInput} from "grommet";
import AppBar from "../component/AppBar";
import HeaderApp from "../component/HeaderApp";
import FooterApp from "../component/Footer/FooterApp";
import {deepMerge} from "grommet/utils";
import api from "../utils/api";
import OfferList from "../component/OfferList";


const Offers = () => {
    const [offers, setOffers] = useState([]);
    useEffect(() => {
        api.get(process.env.REACT_APP_BASE_API_URL + 'api/offers.json')
            .then(response => {
                setOffers(response.data);
                //setStoreOffers(response.data.storeOffers);
                //setStores(response.data.stores);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);


    const theme = deepMerge(grommet, {
        global: {
            colors: {
                brand: '#C01219',
            },
            font: {
                family: "Playfair Display",
                size: "18px",
                height: "20px",
            },
        },
    });
    return (
        <Grommet theme={theme} full>
            <Box fill>
                <Box flex={false} tag="header">
                    <AppBar>
                        <HeaderApp />
                    </AppBar>
                </Box>
                <Box flex overflow="auto" animation={"zoomIn"}>
                    <Grid columns="medium" gap="medium" pad={{bottom: "medium"}} responsive={true}>
                        <OfferList offers={offers}/>
                        {/*<Card background="light-1" border="dark">
                            <CardHeader pad="medium">
                                <Text weight={"bold"} color={"brand"}>
                                    Personal Info
                                </Text>
                            </CardHeader>
                            <CardBody pad="medium">
                                <Box direction={"row"} pad={"small"} gap={"medium"}>
                                    <Text alignSelf={"center"} wordBreak={"break-all"}>
                                        Matteo Domenici
                                    </Text>
                                    <Image
                                        fit="cover"
                                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/330px-QR_code_for_mobile_English_Wikipedia.svg.png"
                                    />

                                </Box>
                            </CardBody>
                            <CardFooter pad={{horizontal: "small"}} background="light-3">
                                <Button icon={<ShareOption color="plain"/>} hoverIndicator/>
                            </CardFooter>
                        </Card>*/}

                        {/*
            <Box pad="medium" gap="medium" width="large" direction={"row"}>
                <Card background="white" border="dark">
                    <CardBody pad="small">
                        <Box direction={"column"} pad={"medium"} gap={"small"}>
                            <Image
                                fit="cover"
                                src="https://cdn-icons-png.flaticon.com/512/657/657076.png"
                            />
                            <Text weight={"lighter"} color={"brand"} wordBreak={"keep-all"}>
                                Card Info
                            </Text>
                        </Box>
                    </CardBody>
                </Card>
                <Card background="white" border="dark">
                    <CardBody pad="small">
                        <Box direction={"column"} pad={"medium"} gap={"small"}>
                            <Image
                                fit="contain"
                                src="https://cdn-icons-png.flaticon.com/512/1507/1507683.png"
                            />
                            <Text weight={"lighter"} color={"brand"} wordBreak={"keep-all"}>
                                Scan QR code
                            </Text>
                        </Box>
                    </CardBody>
                </Card>
            </Box>
        */}
                    </Grid>
                </Box>
                <Box flex={false} background="brand" >
                    <FooterApp />
                </Box>
            </Box>
        </Grommet>
    );
}

export default Offers;